import Lamho from 'src/assets/images/team_v2/Lam-Ho.png'
import Khuong from 'src/assets/images/team_v2/Khuong-Pham.png'
import Khoi from 'src/assets/images/team_v2/Khoi-Huynh.png'
import Hai from 'src/assets/images/team_v2/Hai-Hoang.png'
import HungNP from 'src/assets/images/team_v2/Hung-Nguyen.png'
import phuc from 'src/assets/images/team_v2/Phuc-Nguyen.png'
import PhuongNgo from 'src/assets/images/team_v2/Phuong-Ngo.png'
import Phuongmac from 'src/assets/images/team_v2/Phuong-Mac.png'
import DinhNguyen from 'src/assets/images/team_v2/Dinh-Nguyen.png'
import QueTran from 'src/assets/images/team_v2/Que-Tran.png'

export const description: string = `With more than 10 years of experience in game development, we quickly understand that the explosion and growth of blockchain technology allows us to apply it to our games. This is an opportunity to lead and make a breakthrough in the field of GameFi. Now these games are no longer regular games, through GameFi and blockchain technology, they allow players to earn a lot of money and NFT items in the game which are assets that can also be bought and sold like real-life goods. With the aim of leading the GameFi market, we need help from those of you who are ready to embark on a never-ending adventure. See you at Senspark.`

export const DesWorkHard: string = `We believe that the most valuable asset of a company is its human resources, that's why we constantly strive to create a good environment so that our people always feel happy while working. We also support employees in their role and development, offer private sales, organize field trips to unite and inspire the whole team.`

type ListTeam = {
  img: any
  name: string
  position: string
}

export const listTeam: ListTeam[] = [
  {img: Lamho, name: 'Lam Ho', position: `Founder & CEO`},
  {img: Hai, name: 'Hai Hoang', position: `Lead Engineer`},
  {img: Khoi, name: 'Khoi Huynh', position: `Lead Product Manager`},
  // {img: PhuongNgo, name: 'Phuong Ngo', position: `Marketing Team Lead`},
  //
  // {img: Khuong, name: 'Khuong Pham', position: `Lead Project Manager`},
  // {img: DinhNguyen, name: 'Dinh Nguyen', position: `Lead Engineer`},
  // {img: HungNP, name: 'Hung Nguyen', position: `Lead Game Designer & Artist`},


  {img: phuc, name: 'Phuc Nguyen', position: `Graphics Design Team Lead`},
  {img: QueTran, name: 'Que Tran', position: `Finance Team Lead`},
  {img: Phuongmac, name: 'Phuong Mac', position: `HR Team Lead`},
]
